import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type ListFilter } from '../types/filters';

export const workScheduleDefinition: FilterDefinition<ListFilter> = {
  id: FilterId.WORK_SCHEDULE,
  name: 'Work Schedule',
  selectionListId: 'work_schedule',
  selections: [],
  type: FilterType.LIST,
  isVisible: true,
};

export const workScheduleHandler: FilterHandler<ListFilter> = {
  isActive(currentFilterState: ListFilter) {
    return currentFilterState.selections.length > 0;
  },
  isDefault(currentFilterState: ListFilter) {
    return currentFilterState.selections.length === 0;
  },
  getEffectiveFilter(currentFilterState: ListFilter) {
    return { ...currentFilterState };
  },
  getRequiredSelectionListIds(definition: FilterDefinition<ListFilter>) {
    return [definition.selectionListId];
  },
};
